import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=64f0491f&scoped=true"
import script from "./groupInfo.vue?vue&type=script&lang=js"
export * from "./groupInfo.vue?vue&type=script&lang=js"
import style0 from "./groupInfo.vue?vue&type=style&index=0&id=64f0491f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f0491f",
  null
  
)

export default component.exports